import React, { useState } from 'react';
import { ChevronRight, ChevronLeft, Dot as DotIcon } from 'lucide-react';

interface ImageSlidesProps {
    slides: {
        url: string;
        name: string;
    }[];
}


function ImageSlides(props) {
    const slides = props.slides;

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === slides.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    const goToSlide = (slideIndex) => {
        setCurrentIndex(slideIndex);
    };

    if (slides.length === 0) return null;

    
    const imageOriginalUrl = slides[currentIndex].url
    let imageUrl = imageOriginalUrl
    let domain = (new URL(imageOriginalUrl)).hostname
    if (domain === "p1.mingdaoyun.cn") {
        imageUrl = imageOriginalUrl.replace("p1.mingdaoyun.cn", "p1-mingdaoyun.chunhuizk.com")
    }

    return (
        <div className='w-full relative group'>
            <div

                className='w-full h-full rounded-2xl bg-center bg-cover duration-500'
            >
                <img
                    style={{ maxHeight: '400px'}}
                    src={imageUrl}
                    alt={slides[currentIndex].name}
                    className="inline rounded-md"
                    />

            </div>
            {/* Left Arrow */}
            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <ChevronLeft onClick={() => { prevSlide() }} />
            </div>
            {/* Right Arrow */}
            <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                <ChevronRight onClick={() => { nextSlide() }} />
            </div>
            <div className='flex top-4 justify-center py-2'>
                {slides.map((_, slideIndex) => (
                    <div
                        key={slideIndex}
                        onClick={() => goToSlide(slideIndex)}
                        className='text-2xl cursor-pointer'
                    >
                        <DotIcon
                            size={32}
                            className={`${slideIndex === currentIndex ? "#1f7000" : '#999999'
                                }`}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ImageSlides;